import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "rc-time-picker/assets/index.css";
import "./TimeInput.scss";

import ReactTimeInput from "rc-time-picker";
import moment from "moment";

const format = "hh:mm A";

class TimeInput extends React.Component {
  constructor() {
    super();

    this.state = {
      value: undefined,
    };
  }

  render() {
    const {
      meta: { error },
      width,
      input,
    } = this.props;
    let normalizeValue = function (value) {
      if (typeof value === "string" && value.trim() === "") {
        value = null;
      }
      return value;
    };
    let _val = normalizeValue(input.value);

    //formatting data to moment
    _val = _val ? moment(_val, "hh:mm A") : null;
    let showError = !!error;

    let formRowClasses = classNames("form-row-dimension", {
      [`mobile-lg:grid-col-${width}`]: true,
    });

    let inputClasses = classNames("usa-textarea", "margin-bottom-3", {
      "usa-input-error": showError,
    });

    return (
      <div className="grid-row grid-gap">
        <div className={formRowClasses}>
          <ReactTimeInput
            id={input.name}
            name={input.name}
            showSecond={false}
            format={format}
            use12Hours
            inputReadOnly
            classes={inputClasses}
            value={_val}
            tabIndex={0}
            onKeyPress={(e) => {
              if (e.key === "Enter" || e.key === "Unidentified") {
                // for crossbrowser
                e.preventDefault(); // this code prevents other buttons triggers use this
              }
            }}
            onBlur={(e) => input.onBlur(e)}
            onChange={(e) => {
              if (!e || !e.format) {
                input.onChange(null);
              } else {
                input.onChange(e.format("h:mm A"));
              }
            }}
            limitMaxLength={false}
          />

          {showError && (
            <div className="usa-error-message" role="alert">
              {error}
            </div>
          )}
        </div>
      </div>
    );
  }
}

TimeInput.propTypes = {
  toolTip: PropTypes.bool,
  toolTipContent: PropTypes.string,
  label: PropTypes.string.isRequired,
  width: PropTypes.number,
};

export default TimeInput;
